export const REQUIRED_CSV_FILES = [
    'RVTools_tabvInfo.csv',
    'RVTools_tabvCPU.csv',
    'RVTools_tabvMemory.csv',
    'RVTools_tabvDisk.csv',
    'RVTools_tabvPartition.csv',
];

export const REQUIRED_EXCEL_SHEETS = ['vInfo', 'vCPU', 'vMemory', 'vDisk', 'vPartition'];

export const UPLOAD_STATUS = {
    pending: 'Pending',
    running: 'In Progress',
    success: 'Completed',
    error: 'Error',

    // TODO: Remove these temp statses after backend is complete
    in_progress: 'In Progress',
    upload_success: 'Completed',
    upload_error: 'Upload Error',
    unknow: 'An Unknown Error Occurred',
};

export const RV_TOOLS_UPLOAD_SIZE_LIMIT = {
    compressedMB: 10,
    uncompressedMB: 50,
};

export const INVENTORY_STATUS = {
    ready: { text: 'Ready', toolTip: 'No optimization actions pending.' },
    not_ready: { text: 'Not Ready', toolTip: 'Optimization actions required.' },
    unknown: { text: 'Unknown', toolTip: 'Insufficient data for assessment.' },
    null: { text: 'Unknown', toolTip: 'Insufficient data for assessment.' },
};

export const MARK_READY_WARNING = "VM's without an IPv4 IP address cannot be marked as ready.";
export const SEND_TO_MIGRATION_WARNING = "Only VM's marked as Ready can be moved to Migration.";

export const SUMMARY_SECTION_TOOLTIP =
    'Oversized and undersized status is based on average utilization thresholds. Resources using 20% or under are flagged as oversized, and those 80% or over are flagged as undersized.';

export const MISSING_CORRUPT_ERRORS = {
    excel: {
        title: 'The Excel file is corrupt or missing a required sheet',
        body: "We couldn't process your Excel file because one or more required Excel sheets are missing or corrupt. Make sure your export contains the following RV Tools sheets:",
        requiredFiles: REQUIRED_EXCEL_SHEETS,
    },
    csv: {
        title: 'One or more files are missing or corrupt',
        body: "We couldn't process your ZIP because one or more required CSV files are missing or corrupt. Make sure your export contains the following RV Tools files:",
        requiredFiles: REQUIRED_CSV_FILES,
    },
};
